import styles from "./DescriptionList.module.css";

export default function DescriptionList() {
    return (
        <div className={styles[`container`]}>
            <div className={styles[`service`]}>
                <div className={styles[`service-title`]}>MojaTV</div>
                <div className={styles[`service-description`]}>
                    Uz osnovni i prošireni mojaTV paket pripremili smo ti
                    dodatne TV kanale za još više zabave! Znamo da je odgovor na
                    pitanje koji TV paket odabrati težak – tu smo za sva pitanja
                    i informacije koje te zanimaju kako bi lakše izabrao onaj
                    idealan za sebe.
                </div>
            </div>
            <div className={styles[`service`]}>
                <div className={styles[`service-title`]}>Telefon</div>
                <div className={styles[`service-description`]}>
                    Usluga GT-net fiksne telefonije dostupna ti je ako imaš
                    pristup Internetu bilo kojeg providera. Nudimo ti puno
                    povoljnije cijene razgovora, mogućnost korištenja na više
                    različitih tipova uređaja te kontrolu troškova u svakom
                    trenutku.
                </div>
            </div>
        </div>
    );
}
